// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3ef_C","header":"MergedInvoice_header__t2ike"};